import { buildUrl } from '@/helpers/buildUrl';

export enum API_VERSION {
  V1 = 'v1',
  V2 = 'v2'
}

// https://api.dev.trueplay.io/api/v1/app/api-gateway/webjars/swagger-ui/index.html?urls.primaryName=Streamers%20Admin%20Service%20(Admin%20API)
export const BASE = (version: string = API_VERSION.V1): string =>
  `/api/${version}/app/control`;

export const BASE_OPERATOR = (version: string = API_VERSION.V1): string =>
  buildUrl(`${BASE(version)}/{operatorId}`);

// https://api.dev.trueplay.io/api/v1/app/api-gateway/webjars/swagger-ui/index.html?urls.primaryName=Streamers%20Web%20Service%20(Admin%20API)
export const BASE_WEB = (version: string = API_VERSION.V1): string =>
  `/api/${version}/app/web`;

export const BASE_WEB_OPERATOR = (version: string = API_VERSION.V1): string =>
  buildUrl(`${BASE_WEB(version)}/admin/{operatorId}`);

// https://api.dev.trueplay.io/api/v1/app/api-gateway/webjars/swagger-ui/index.html?urls.primaryName=Streamers%20Game%20Center%20Service%20(Admin%20API)
export const BASE_GAME_CENTER = (version: string = API_VERSION.V1): string =>
  `/api/${version}/app/game-center`;

export const BASE_GAME_CENTER_OPERATOR = (
  version: string = API_VERSION.V1
): string => buildUrl(`${BASE_GAME_CENTER(version)}/admin/{operatorId}`);
